export default "__VITE_ASSET__BQvyw2yh__"